import React from 'react';
import { bool, func } from 'prop-types';
import AuctionForm from './AuctionForm';
import { history } from 'data/Store';

const NewAuction = ({
  auctionCreated,
  clearCreatedAuction,
  folder,
  onSubmit,
  ...props
}) => {
  // Reset state data when auction created
  React.useEffect(() => {
    if (auctionCreated) {
      clearCreatedAuction();
      history.replace({
        pathname: `/auctions/${auctionCreated}`,
      });
    }
  }, [clearCreatedAuction, auctionCreated, folder]);

  // Needed when creating new auction from folder
  const formattedFolder = React.useMemo(
    () =>
      folder && {
        Number: folder.FolderNumber,
        PlateNumber: folder.PlateNumber,
        Title: folder.FolderTitle,
        VehicleBrand: folder.VehicleBrand,
        VehicleModel: folder.VehicleModel,
        VehicleRegistrationYear: folder.VehicleRegistrationYear,
        VehicleDoors: folder.VehicleDoors,
        VehicleEngine: folder.VehicleEngine,
        VehicleEngineCapacity: folder.VehicleEngineCapacity,
      },
    [folder]
  );

  // override folderID when folder exists
  const handleSubmit = React.useCallback(
    ({ folderData, ...data }) => {
      onSubmit({
        ...data,
        folderData: folder
          ? {
              ...folderData,
              ID: folder.FolderID,
            }
          : folderData,
      });
    },
    [folder, onSubmit]
  );

  return (
    <AuctionForm folder={formattedFolder} {...props} onSubmit={handleSubmit} />
  );
};

NewAuction.propTypes = {
  auctionCreated: bool,
  clearCreatedAuction: func,
  ...AuctionForm.propTypes,
};

export default NewAuction;
